import { actions } from '../../context';
import {
    IS_ADD_NEW_OFFERING_FORM_COLLAPSE_OPEN,
    IS_NOTE_BEING_ADDED,
    IS_VIEW_ADDING_NEW_COMMUNICATION,
    TOGGLE_ASSIGN_MODAL,
    TOGGLE_ASSIGN_MODAL_DROPDOWN,
    TOGGLE_CONNECTIVITY_CALENDAR_VISABILITY,
    TOGGLE_CONNECTIVITY_CONFIG_FORM_VALID,
    TOGGLE_CONNECTIVITY_MODAL,
    TOGGLE_CONNECTIVITY_MODAL_PARTNER_DROPDOWN,
    TOGGLE_CONNECTIVITY_MODAL_PRACTICE_DROPDOWN,
    TOGGLE_CONNECT_CONFIG_MODAL_COLLAPSE,
    TOGGLE_CREATE_PARTNER_MODAL,
    TOGGLE_CREATE_PRACTICE_MODAL,
    TOGGLE_DASHBOARD_VISIBLE,
    TOGGLE_DELETE_SYNC_CONFIRMATION_MODAL,
    TOGGLE_EDIT_FORM_TABLE_IS_EDITING,
    TOGGLE_EDIT_GROUP_FORM_EDITING,
    TOGGLE_EDIT_PARTNER_FORM_INVALID,
    TOGGLE_EDIT_PARTNER_MODAL,
    TOGGLE_EDIT_PARTNER_MODAL_COLLAPSE,
    TOGGLE_EDIT_PRACTICE_FORM_EDITING,
    TOGGLE_EDIT_TAG_FORM_EDITING,
    TOGGLE_EDIT_USER_FORM_EDITING,
    TOGGLE_GETTING_PRACTICE,
    TOGGLE_IGNORE_FAILED_SYNC_MODAL,
    TOGGLE_ASSIGN_USER_TO_PRACTICE_MODAL,
    TOGGLE_IS_PRACTICE_SUMMARY_OPEN,
    TOGGLE_IS_RELATIONS_MODAL_OPEN,
    TOGGLE_NAVBAR_TOGGLER,
    TOGGLE_NEW_GROUP_FORM,
    TOGGLE_NEW_PARTNER_MODAL_COLLAPSE,
    TOGGLE_NEW_PRACTICE_MODAL,
    TOGGLE_NEW_TAG_FORM,
    TOGGLE_NEW_USER_FORM,
    TOGGLE_PENDING_PRACTICE_MODAL,
    TOGGLE_PRACTICE_CONFIG_MODAL,
    TOGGLE_REFRESH,
    TOGGLE_REQUEST_FORM_INVALID,
    TOGGLE_REQUEST_TAB_PARTNER_DROPDOWN,
    TOGGLE_REQUEST_TAB_PRACTICE_DROPDOWN,
    TOGGLE_SYNC_SCHEDULER_IS_EDITING,
    TOGGLE_TAG_CONNECTION_DROPDOWN,
    TOGGLE_TAG_TIER_DROPDOWN,
    TOGGLE_WORKFLOW_CONFIG_MODAL,
    TOGGLE_WORKFLOW_EDIT_PRACTICE_MODAL,
    TOGGLE_WORKFLOW_OFFERING_MODAL,
    TOGGLE_WORKFLOW_SCHEDULE_MODAL,
    TOGGLE_WORKFLOW_SELECT_MODAL,
    TOGGLE_WORKFLOW_TRANSITION,
    USELESS_TOGGLE,
    TOGGLE_COMMUNICATIONS_TRANSITION,
    TOGGLE_SCHEDULE_MODAL,
    TOGGLE_UPDATE_NOTES_MODAL,
    TOGGLE_EDITING_PRACTICE,
    TOGGLE_PRACTICE_REFRESH,
    TOGGLE_REFRESH_ACTIVITIES,
    TOGGLE_SIDEBAR_OPEN,
    TOGGLE_TEXT_PRACTICE_SEARCH,
    TOGGLE_PRACTICE_WORKFLOW_MODAL,
    TOGGLE_EDIT_CONVERSION_PIMS_MODAL,
    TOGGLE_RESET_CONVERSION_MODAL,
    TOGGLE_PLUGIN_DETAIL_MODAL,
    TOGGLE_CONNECT_PLUGIN_DETAIL_MODAL_COLLAPSE,
    TOGGLE_PLUGINOFFERING_ADD_MODAL,
    TOGGLE_PLUGINOFFERING_ADD_MODAL_COLLAPSE,
    TOGGLE_LEADS_GENERATION_CONFIRMATION_MODAL
} from '../ActionTypes';

const initActions = function (services) {
    const toggleResetConversionModalOpen = (status) => {
        return {
            type: TOGGLE_RESET_CONVERSION_MODAL,
            payload: status,
        };
    };
    
    const toggleEditConversionPimsModalOpen = (status) => {
        return {
            type: TOGGLE_EDIT_CONVERSION_PIMS_MODAL,
            payload: status,
        };
    };
    
    const toggleEditPartnerModalIsEditing = (status) => {
        return {
            type: TOGGLE_EDIT_FORM_TABLE_IS_EDITING,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleEditingPractice = (status) => {
        return {
            type: TOGGLE_EDIT_PRACTICE_FORM_EDITING,
            payload: {
                isEditing: status,
            },
        };
    };

    const toggleNavBarToggle = (status) => {
        return {
            type: TOGGLE_NAVBAR_TOGGLER,
            payload: {
                isOpen: status,
            },
        };
    };

    function toggleAssignedModal(practiceId, status) {
        return {
            type: TOGGLE_ASSIGN_MODAL,
            payload: { practiceId, status },
        };
    }

    function toggleAssignedModalDropdown(practiceId, status) {
        return {
            type: TOGGLE_ASSIGN_MODAL_DROPDOWN,
            payload: { practiceId, status },
        };
    }

    const toggleConnectConfigModal = (status) => {
        return {
            type: TOGGLE_PRACTICE_CONFIG_MODAL,
            payload: status,
        };
    };

    const toggleConnectPluginDetailModal = (status) => {
        return {
            type: TOGGLE_PLUGIN_DETAIL_MODAL,
            payload: status,
        };
    };

    const toggleNewPracticeModal = (status) => {
        return {
            type: TOGGLE_NEW_PRACTICE_MODAL,
            payload: status,
        };
    };

    const toggleConnectivityModal = (status) => {
        return {
            type: TOGGLE_CONNECTIVITY_MODAL,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleConnectivityModalPartnerDropdown = (status) => {
        return {
            type: TOGGLE_CONNECTIVITY_MODAL_PARTNER_DROPDOWN,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleConnectivityModalPracticeDropdown = (status) => {
        return {
            type: TOGGLE_CONNECTIVITY_MODAL_PRACTICE_DROPDOWN,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleCreatePartnerModal = (status) => {
        return {
            type: TOGGLE_CREATE_PARTNER_MODAL,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleCreatePracticeModal = (status) => {
        return {
            type: TOGGLE_CREATE_PRACTICE_MODAL,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleNewPartnerModalCollapse = (status) => {
        return {
            type: TOGGLE_NEW_PARTNER_MODAL_COLLAPSE,
            payload: { isOpen: status },
        };
    };

    const toggleEditPartnerModal = (status) => {
        return {
            type: TOGGLE_EDIT_PARTNER_MODAL,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleEditPartnerModalCollapse = (status) => {
        return {
            type: TOGGLE_EDIT_PARTNER_MODAL_COLLAPSE,
            payload: {
                isOpen: status,
            },
        };
    };

    const togglePracticeSummaryCollapse = (status) => {
        return {
            type: TOGGLE_IS_PRACTICE_SUMMARY_OPEN,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleRelationsModalOpen = (status) => {
        return {
            type: TOGGLE_IS_RELATIONS_MODAL_OPEN,
            payload: status,
        };
    };

    const toggleConnectConfigModalCollapse = (status) => {
        return {
            type: TOGGLE_CONNECT_CONFIG_MODAL_COLLAPSE,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleConnectPluginDetailModalCollapse = (status) => {
        return {
            type: TOGGLE_CONNECT_PLUGIN_DETAIL_MODAL_COLLAPSE,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleEditingSyncSchedule = (status) => {
        return {
            type: TOGGLE_SYNC_SCHEDULER_IS_EDITING,
            payload: {
                isEditing: status,
            },
        };
    };

    const toggleConnectionCalanderVisability = (status) => {
        return {
            type: TOGGLE_CONNECTIVITY_CALENDAR_VISABILITY,
            payload: {
                isVisable: status,
            },
        };
    };

    const toggleUselessToggle = (status) => {
        return {
            type: USELESS_TOGGLE,
            payload: {
                toggle: status,
            },
        };
    };

    const toggleDeleteSyncConfirmationModal = (status) => {
        return {
            type: TOGGLE_DELETE_SYNC_CONFIRMATION_MODAL,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleEditingGroupForm = (status) => {
        return {
            type: TOGGLE_EDIT_GROUP_FORM_EDITING,
            payload: {
                isEditing: status,
            },
        };
    };

    const toggleEditingTagForm = (status) => {
        return {
            type: TOGGLE_EDIT_TAG_FORM_EDITING,
            payload: {
                isEditing: status,
            },
        };
    };

    const toggleEditingUserForm = (status) => {
        return {
            type: TOGGLE_EDIT_USER_FORM_EDITING,
            payload: {
                isEditing: status,
            },
        };
    };

    const toggleRequestTabPartnerDropdown = (status) => {
        return {
            type: TOGGLE_REQUEST_TAB_PARTNER_DROPDOWN,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleTagTierDropdown = (status) => {
        return {
            type: TOGGLE_TAG_TIER_DROPDOWN,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleRequestTabPracticeDropdown = (status) => {
        return {
            type: TOGGLE_REQUEST_TAB_PRACTICE_DROPDOWN,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleTagConnectionDropdown = (status) => {
        return {
            type: TOGGLE_TAG_CONNECTION_DROPDOWN,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleNewTagForm = (status) => {
        return {
            type: TOGGLE_NEW_TAG_FORM,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleNewUserForm = (status) => {
        return {
            type: TOGGLE_NEW_USER_FORM,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleNewGroupForm = (status) => {
        return {
            type: TOGGLE_NEW_GROUP_FORM,
            payload: {
                isOpen: status,
            },
        };
    };

    const togglePendingPracticeModal = (status) => {
        return {
            type: TOGGLE_PENDING_PRACTICE_MODAL,
            payload: {
                isOpen: status,
            },
        };
    };

    function setIsNoteBeingAdded(practiceId, status) {
        return {
            type: IS_NOTE_BEING_ADDED,
            payload: { practiceId, status },
        };
    }

    const toggleRequestFormInvalid = (status) => {
        return {
            type: TOGGLE_REQUEST_FORM_INVALID,
            payload: {
                invalid: status,
            },
        };
    };

    const toggleEditPartnerFormInvalid = (status) => {
        return {
            type: TOGGLE_EDIT_PARTNER_FORM_INVALID,
            payload: {
                invalid: status,
            },
        };
    };

    const toggleMutePracticeModal = (status) => {
        return {
            type: TOGGLE_IGNORE_FAILED_SYNC_MODAL,
            payload: {
                isOpen: status,
            },
        };
    };
    
    const toggleAssignUserToPracticeModal = (status) => {
        return {
            type: TOGGLE_ASSIGN_USER_TO_PRACTICE_MODAL,
            payload: {
                isOpen: status,
            },
        };
    };

    const toggleIsViewAddingNewCommunication = (status) => {
        return {
            type: IS_VIEW_ADDING_NEW_COMMUNICATION,
            payload: status,
        };
    };

    const toggleLeadsGenerationConfirmationModal = (status) => {
        return {
            type: TOGGLE_LEADS_GENERATION_CONFIRMATION_MODAL,
            payload: status,
        };
    };

    const toggleConnectivityConfigFormValid = (status) => {
        return {
            type: TOGGLE_CONNECTIVITY_CONFIG_FORM_VALID,
            payload: status,
        };
    };

    const toggleAddNewOfferingFormCollapseIsOpen = (status) => {
        return {
            type: IS_ADD_NEW_OFFERING_FORM_COLLAPSE_OPEN,
            payload: status,
        };
    };

    const toggleDashboardVisible = (status = false) => {
        return {
            type: TOGGLE_DASHBOARD_VISIBLE,
            payload: status,
        };
    };

    // forces a call to get the practices list
    // used by the data sync but also is called by components to cause an immediate update
    // TODO: needs refactor when refactor of data sync occurs
    const triggerRefresh = () => {
        return async (dispatch) => {
            // TODO: putting this here means I need to take it out of other places
            dispatch(actions.practice.getDashboardStats());
            dispatch(toggleRefreshValue());
        }
    };
    const toggleRefreshValue = () => {
        return {
                type: TOGGLE_REFRESH,
            };
    }

    const activitiesRefresh = () => {
        return {
            type: TOGGLE_REFRESH_ACTIVITIES,
        };
    };

    const triggerPracticeRefresh = () => {
        return {
            type: TOGGLE_PRACTICE_REFRESH,
        };
    };

    const toggleGettingPractice = (status = false) => {
        return {
            type: TOGGLE_GETTING_PRACTICE,
            payload: status,
        };
    };

    const togglePracticeWorkflowTransition = (status = false) => {
        return {
            type: TOGGLE_WORKFLOW_TRANSITION,
            payload: status,
        };
    };

    const togglePracticeWorkflowSelectModal = (status = false) => {
        return {
            type: TOGGLE_WORKFLOW_SELECT_MODAL,
            payload: status,
        };
    };

    const togglePracticeWorkflowEditModal = (status = false) => {
        return {
            type: TOGGLE_WORKFLOW_EDIT_PRACTICE_MODAL,
            payload: status,
        };
    };

    const togglePracticeWorkflowOfferingModal = (status = false) => {
        return {
            type: TOGGLE_WORKFLOW_OFFERING_MODAL,
            payload: status,
        };
    };

    const togglePracticeConfigModal = (status = false) => {
        return {
            type: TOGGLE_WORKFLOW_CONFIG_MODAL,
            payload: status,
        };
    };

    const togglePracticeWorkflowScheduleModal = (status = false) => {
        return {
            type: TOGGLE_WORKFLOW_SCHEDULE_MODAL,
            payload: status,
        };
    };

    const togglePracticeScheduleModal = (status = false) => {
        return {
            type: TOGGLE_SCHEDULE_MODAL,
            payload: status,
        };
    };

    const toggleCommunicationsTransition = (status = false) => {
        return {
            type: TOGGLE_COMMUNICATIONS_TRANSITION,
            payload: status,
        };
    };

    const toggleUpdateNotesModal = (status = false) => {
        return {
            type: TOGGLE_UPDATE_NOTES_MODAL,
            payload: status,
        };
    };

    const toggleIsEditingPractice = (status = false) => {
        return {
            type: TOGGLE_EDITING_PRACTICE,
            payload: status,
        };
    };
 
    const toggleSidebarOpen = (status) => {
        return {
            type: TOGGLE_SIDEBAR_OPEN,
            payload: status,
        };
    };
    
    const toggleSidebarPracticeSearchOpen = (bool) => {
        return {
            type: TOGGLE_TEXT_PRACTICE_SEARCH,
            payload: bool,
        };
    };
    
    const togglePracticeWorkflowModalOpen = (bool) => {
        return {
            type: TOGGLE_PRACTICE_WORKFLOW_MODAL,
            payload: bool,
        };
    };

    const toggleAddNewPluginOfferingModal = (status) => {
        return {
            type: TOGGLE_PLUGINOFFERING_ADD_MODAL,
            payload: status,
        };
    };

    const toggleAddNewPluginOfferingModalCollapse = (status) => {
        return {
            type: TOGGLE_PLUGINOFFERING_ADD_MODAL_COLLAPSE,
            payload: {
                isOpen: status,
            },
        };
    };

    return {
        toggleResetConversionModalOpen,
        toggleEditConversionPimsModalOpen,
        setIsNoteBeingAdded,
        toggleAddNewOfferingFormCollapseIsOpen,
        toggleAssignedModal,
        toggleAssignedModalDropdown,
        toggleCommunicationsTransition,
        toggleConnectConfigModal,
        toggleConnectConfigModalCollapse,
        toggleConnectionCalanderVisability,
        toggleConnectivityConfigFormValid,
        toggleConnectivityModal,
        toggleConnectivityModalPartnerDropdown,
        toggleConnectivityModalPracticeDropdown,
        toggleCreatePartnerModal,
        toggleCreatePracticeModal,
        toggleDashboardVisible,
        toggleDeleteSyncConfirmationModal,
        toggleEditPartnerFormInvalid,
        toggleEditPartnerModal,
        toggleEditPartnerModalCollapse,
        toggleEditPartnerModalIsEditing,
        toggleEditingGroupForm,
        toggleEditingPractice,
        toggleIsEditingPractice,
        toggleEditingSyncSchedule,
        toggleEditingTagForm,
        toggleEditingUserForm,
        toggleGettingPractice,
        toggleMutePracticeModal,
        toggleAssignUserToPracticeModal,
        toggleIsViewAddingNewCommunication,
        toggleLeadsGenerationConfirmationModal,
        toggleNavBarToggle,
        toggleNewGroupForm,
        toggleNewPartnerModalCollapse,
        toggleNewPracticeModal,
        toggleNewTagForm,
        toggleNewUserForm,
        togglePendingPracticeModal,
        togglePracticeSummaryCollapse,
        toggleRequestFormInvalid,
        toggleRequestTabPartnerDropdown,
        toggleRequestTabPracticeDropdown,
        toggleRelationsModalOpen,
        toggleTagConnectionDropdown,
        toggleTagTierDropdown,
        toggleUselessToggle,
        triggerRefresh,
        triggerPracticeRefresh,
        togglePracticeWorkflowSelectModal,
        togglePracticeWorkflowTransition,
        togglePracticeWorkflowEditModal,
        togglePracticeWorkflowOfferingModal,
        togglePracticeConfigModal,
        togglePracticeWorkflowScheduleModal,
        togglePracticeScheduleModal,
        toggleUpdateNotesModal,
        activitiesRefresh,
        toggleSidebarOpen,
        toggleSidebarPracticeSearchOpen,
        togglePracticeWorkflowModalOpen,
        toggleConnectPluginDetailModal,
        toggleConnectPluginDetailModalCollapse,
        toggleAddNewPluginOfferingModal,
        toggleAddNewPluginOfferingModalCollapse
    };
};

export default initActions;
